import { PremiumDatabaseApplicationType } from '@baserow_premium/applicationTypes'

import BotonDeFila from '@extras_mg/components/BotonDeFila'

/**
 * La base de datos tal como la deja premium (que ya reemplaza a la del core),
 * con un solo cambio: el botón de abrir la fila en la cuadrícula lleva al lado
 * el aviso de fila inválida de la dependencia de fechas. Ver BotonDeFila.
 *
 * Hereda de la de premium y no de la del core para no perder su conteo de
 * comentarios, que BotonDeFila sigue pintando.
 */
export class DatabaseMGApplicationType extends PremiumDatabaseApplicationType {
  getRowExpandButtonComponent() {
    return BotonDeFila
  }
}
